module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/logout/logout.html
 ** module id = 665
 ** module chunks = 0
 **/